<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"


  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="120px"
    >
      <el-row :gutter="80">
        <el-col :span="11">
          <el-form-item label="供应商代码*" prop="venderCode">
            <el-input v-model="dataForm.venderCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="供应商名称*" prop="venderName">
            <el-input v-model="dataForm.venderName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="80">
        <el-col :span="11">
          <el-form-item label="供应商简称*" prop="venderAbbreviation">
            <el-input v-model="dataForm.venderAbbreviation"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="供应商地址*" prop="venderAdd">
            <el-input v-model="dataForm.venderAdd"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="80">
        <el-col :span="11">
          <el-form-item label="联系人*" prop="venderContacts">
            <el-input v-model="dataForm.venderContacts"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="邮箱*" prop="venderMail">
            <el-input v-model="dataForm.venderMail"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-form-item label="供应商备用邮箱" prop="venderMailBak">
      <el-input v-model="dataForm.venderMailBak" placeholder="供应商备用邮箱"></el-input>
    </el-form-item> -->
      <el-row :gutter="80">
        <el-col :span="11">
          <el-form-item label="电话*" prop="venderTel">
            <el-input v-model="dataForm.venderTel"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="供应商类别" prop="venderSource">
            <el-input v-model="dataForm.venderSource"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-form-item label="创建人" prop="createdBy">
      <el-input v-model="dataForm.createdBy" placeholder="创建人"></el-input>
    </el-form-item>
    <el-form-item label="创建时间" prop="createDate">
      <el-input v-model="dataForm.createDate" placeholder="创建时间"></el-input>
    </el-form-item>
    <el-form-item label="修改人" prop="updatedBy">
      <el-input v-model="dataForm.updatedBy" placeholder="修改人"></el-input>
    </el-form-item>
    <el-form-item label="修改时间" prop="updateDate">
      <el-input v-model="dataForm.updateDate" placeholder="修改时间"></el-input>
    </el-form-item>
    <el-form-item label="删除人" prop="deletedBy">
      <el-input v-model="dataForm.deletedBy" placeholder="删除人"></el-input>
    </el-form-item>
    <el-form-item label="删除时间" prop="deleteDate">
      <el-input v-model="dataForm.deleteDate" placeholder="删除时间"></el-input>
    </el-form-item>
    <el-form-item label="删除标识:‘0’未删除；‘1’已删除" prop="isDeleted">
      <el-input v-model="dataForm.isDeleted" placeholder="删除标识:‘0’未删除；‘1’已删除"></el-input>
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
    </el-form-item>
    <el-form-item label="版本号" prop="optCounter">
      <el-input v-model="dataForm.optCounter" placeholder="版本号"></el-input>
    </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        venderId: 0,
        venderLogin: "",
        venderCareerBody: "",
        venderCode: "",
        venderName: "",
        venderAbbreviation: "",
        venderAdd: "",
        venderContacts: "",
        venderMail: "",
        venderMailBak: "",
        venderTel: "",
        venderSource: "",
        createdBy: "",
        createDate: "",
        updatedBy: "",
        updateDate: "",
        deletedBy: "",
        deleteDate: "",
        isDeleted: "",
        remark: "",
        optCounter: "",
      },
      dataRule: {
        venderLogin: [
          { required: true, message: "供应商账号不能为空", trigger: "blur" },
        ],
        venderCareerBody: [
          { required: true, message: "事业体不能为空", trigger: "blur" },
        ],
        venderCode: [
          { required: true, message: "供应商代码不能为空", trigger: "blur" },
        ],
        venderName: [
          { required: true, message: "供应商名称不能为空", trigger: "blur" },
        ],
        venderAbbreviation: [
          { required: true, message: "供应商简称不能为空", trigger: "blur" },
        ],
        venderAdd: [
          { required: true, message: "供应商地址不能为空", trigger: "blur" },
        ],
        venderContacts: [
          { required: true, message: "联系人不能为空", trigger: "blur" },
        ],
        venderMail: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
        ],
        venderMailBak: [
          {
            required: true,
            message: "供应商备用邮箱不能为空",
            trigger: "blur",
          },
        ],
        venderTel: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
        ],
        venderSource: [
          { required: true, message: "供应商类别不能为空", trigger: "blur" },
        ],
        createdBy: [
          { required: true, message: "创建人不能为空", trigger: "blur" },
        ],
        createDate: [
          { required: true, message: "创建时间不能为空", trigger: "blur" },
        ],
        updatedBy: [
          { required: true, message: "修改人不能为空", trigger: "blur" },
        ],
        updateDate: [
          { required: true, message: "修改时间不能为空", trigger: "blur" },
        ],
        deletedBy: [
          { required: true, message: "删除人不能为空", trigger: "blur" },
        ],
        deleteDate: [
          { required: true, message: "删除时间不能为空", trigger: "blur" },
        ],
        isDeleted: [
          {
            required: true,
            message: "删除标识:‘0’未删除；‘1’已删除不能为空",
            trigger: "blur",
          },
        ],
        remark: [{ required: true, message: "备注不能为空", trigger: "blur" }],
        optCounter: [
          { required: true, message: "版本号不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    init(id) {
      this.dataForm.venderId = id || 0;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.venderId) {
          this.$http({
            url: this.$http.adornUrl(
              `/venderinvite/tvenderinvite/info/${this.dataForm.venderId}`
            ),
            method: "get",
            params: this.$http.adornParams(),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.dataForm.venderLogin = data.tvenderinvite.venderLogin;
              this.dataForm.venderCareerBody =
                data.tvenderinvite.venderCareerBody;
              this.dataForm.venderCode = data.tvenderinvite.venderCode;
              this.dataForm.venderName = data.tvenderinvite.venderName;
              this.dataForm.venderAbbreviation =
                data.tvenderinvite.venderAbbreviation;
              this.dataForm.venderAdd = data.tvenderinvite.venderAdd;
              this.dataForm.venderContacts = data.tvenderinvite.venderContacts;
              this.dataForm.venderMail = data.tvenderinvite.venderMail;
              this.dataForm.venderMailBak = data.tvenderinvite.venderMailBak;
              this.dataForm.venderTel = data.tvenderinvite.venderTel;
              this.dataForm.venderSource = data.tvenderinvite.venderSource;
              this.dataForm.createdBy = data.tvenderinvite.createdBy;
              this.dataForm.createDate = data.tvenderinvite.createDate;
              this.dataForm.updatedBy = data.tvenderinvite.updatedBy;
              this.dataForm.updateDate = data.tvenderinvite.updateDate;
              this.dataForm.deletedBy = data.tvenderinvite.deletedBy;
              this.dataForm.deleteDate = data.tvenderinvite.deleteDate;
              this.dataForm.isDeleted = data.tvenderinvite.isDeleted;
              this.dataForm.remark = data.tvenderinvite.remark;
              this.dataForm.optCounter = data.tvenderinvite.optCounter;
            }
          });
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(
              `/venderinvite/tvenderinvite/${
                !this.dataForm.venderId ? "save" : "update"
              }`
            ),
            method: "post",
            data: this.$http.adornData({
              venderId: this.dataForm.venderId || undefined,
              venderLogin: this.dataForm.venderLogin,
              venderCareerBody: this.dataForm.venderCareerBody,
              venderCode: this.dataForm.venderCode,
              venderName: this.dataForm.venderName,
              venderAbbreviation: this.dataForm.venderAbbreviation,
              venderAdd: this.dataForm.venderAdd,
              venderContacts: this.dataForm.venderContacts,
              venderMail: this.dataForm.venderMail,
              venderMailBak: this.dataForm.venderMailBak,
              venderTel: this.dataForm.venderTel,
              venderSource: this.dataForm.venderSource,
              createdBy: this.dataForm.createdBy,
              createDate: this.dataForm.createDate,
              updatedBy: this.dataForm.updatedBy,
              updateDate: this.dataForm.updateDate,
              deletedBy: this.dataForm.deletedBy,
              deleteDate: this.dataForm.deleteDate,
              isDeleted: this.dataForm.isDeleted,
              remark: this.dataForm.remark,
              optCounter: this.dataForm.optCounter,
            }),
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
  },
};
</script>
